import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import Title from 'components/Title';
import exclusionValues from './constants/exclusion.values'
import AllSections from './components/AllSections';

const style = theme => ({
	root: {
		'&>*': {
			marginTop: theme.spacing(2)
		}
	}
})

function ExclusionSection({
	classes,
	formikProps,
	idPrefix,
	sectorBuyer
}) {
	return (
		<GridBlock
			column
			className={classes.root}
		>
			<Title align='center'>
				{Tr('exclusion_ground')}
			</Title>
			<AllSections
				formikProps={formikProps}
				values={exclusionValues}
				idPrefix={idPrefix}
				sectorBuyer={sectorBuyer}
			/>
		</GridBlock>
	)
}

ExclusionSection.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(ExclusionSection);